const haiso_c_form = document.querySelector('#cart');
const haiso_c_observer = new MutationObserver(haisocfHandleFormChange);
//日付非表示タグ名
const haiso_c_tagName = "tag_日時指定不可";

const haiso_c_attributeKeys = ['haisoyamatoshippingdate', 'haisoyamatoshippingtime'];

function haisocfHandleFormChange(mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {

      mutation.addedNodes.forEach(node => {

          if ($("#haisoShippingdate").length >0) {
             $("#haisoShippingdate").attr("placeholder", "指定なし");
           }
        
        if (node.classList && node.classList.length > 0) {

          const className = node.classList[0];
          if (className.includes("cart-items")) {
            haisocfCheckCartItemsForTag(haiso_c_tagName);
          }
        }
      });

      mutation.removedNodes.forEach(node => {

        if (node.classList && node.classList.length > 0) {

          const className = node.classList[0];
          if (className.includes("cart-items")) {
            haisocfCheckCartItemsForTag(haiso_c_tagName);
          }
        }
      });


    }
  }
}
haiso_c_observer.observe(haiso_c_form, { childList: true, subtree: true });


function haisocfCheckCartItemsForTag(tag) {

  var divElements = document.getElementsByClassName("item_tags");

  const haisoDivToHide = document.getElementById('haisosm');

  if (divElements.length == 0) {
    haisoDivToHide.style.display = 'none';
    haisocfRemoveAttributesWithKeys();
  } else {
    for (var i = 0; i < divElements.length; i++) {
      var divContent = divElements[i].innerHTML;

      if (divContent) {
        if (divContent.includes(tag)) {
          haisoDivToHide.style.display = 'none';
          haisocfRemoveAttributesWithKeys();
          break;
        } else {
          haisoDivToHide.style.display = 'block';
        }
      }
    }
  }
}


function haisocfRemoveAttributesWithKeys() {
  // Retrieve the current cart data
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {
      const cartAttributes = data.attributes;

      for (const key of haiso_c_attributeKeys) {
        if (cartAttributes[key]) {
          data.attributes[key] = ''
        };
      }


      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          haisocfUpdateCurrentAtttibute();
        })
        .catch(error => {
          console.error('Error:', error);
        });
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function haisocfUpdateCurrentAtttibute() {

  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {

      const cartAttributes = data.attributes;
      for (const key of haiso_c_attributeKeys) {
        if (!cartAttributes[key]) {
          const inputElements = document.querySelectorAll(`input[name="attributes[${key}]"]`);
          inputElements.forEach(div => {
            div.value = ''
          });
          const selectElements = document.querySelectorAll(`select[name="attributes[${key}]"]`);
          selectElements.forEach(div => {
            div.value = ''
          });
        };
      }

    })
};

haisocfCheckCartItemsForTag(haiso_c_tagName);